import type { Criterion, CriteriaKey, PresentationType } from './types';

/**
 * Scoring criteria, recovered verbatim from the original AADPA app.
 * Oral and poster sets are weighted (weights sum to 1.0, each criterion 1..5),
 * so a weighted total lands on a 0..5 scale. The livedExperience set is
 * unweighted (raw sum out of 30) and kept for completeness.
 */
export const CRITERIA: Record<CriteriaKey, Criterion[]> = {
  oral: [
    { id: 'relevance', label: 'Relevance to ADHD Field', maxScore: 5, weight: 0.3, description: 'How well the presentation relates to ADHD research or clinical practice' },
    { id: 'methodology', label: 'Methodological Rigour/Approach', maxScore: 5, weight: 0.25, description: 'Quality of research methods or clinical approach' },
    { id: 'results', label: 'Results and Impact', maxScore: 5, weight: 0.2, description: 'Quality of results and their potential impact' },
    { id: 'innovation', label: 'Innovation and Originality', maxScore: 5, weight: 0.15, description: 'Novel approaches or original contributions' },
    { id: 'presentation', label: 'Presentation Quality', maxScore: 5, weight: 0.1, description: 'Clarity of communication and presentation skills' },
  ],
  poster: [
    { id: 'relevance', label: 'Relevance to ADHD Field or Theme', maxScore: 5, weight: 0.25, description: 'How well the poster relates to ADHD research or clinical practice' },
    { id: 'visual', label: 'Visual Clarity and Structure', maxScore: 5, weight: 0.2, description: 'Layout, design, readability, and visual appeal' },
    { id: 'methodology', label: 'Methodology or Perspective', maxScore: 5, weight: 0.15, description: 'Quality of research methods or clinical perspective' },
    { id: 'impact', label: 'Impact and Application', maxScore: 5, weight: 0.15, description: 'Practical implications and potential impact' },
    { id: 'innovation', label: 'Innovation and Originality', maxScore: 5, weight: 0.15, description: 'Novel approaches or original contributions' },
    { id: 'engagement', label: 'Engagement and Communication', maxScore: 5, weight: 0.1, description: 'Clarity of communication and engagement potential' },
  ],
  livedExperience: [
    { id: 'authenticity', label: 'Authenticity', maxScore: 5, description: 'Genuine sharing of personal lived experience' },
    { id: 'insight', label: 'Insight and Reflection', maxScore: 5, description: 'Depth of personal insights and self-reflection' },
    { id: 'relevance', label: 'Relevance', maxScore: 5, description: 'Connection to conference themes and audience needs' },
    { id: 'communication', label: 'Communication', maxScore: 5, description: 'Clarity and effectiveness of storytelling' },
    { id: 'impact', label: 'Impact and Learning', maxScore: 5, description: 'Potential to inspire and educate others' },
    { id: 'courage', label: 'Courage and Vulnerability', maxScore: 5, description: 'Willingness to share personal challenges and growth' },
  ],
};

export function criteriaFor(type: PresentationType): Criterion[] {
  return CRITERIA[type];
}
